import React, {useEffect, useState} from 'react';
import {Grid, List, ListItem} from "@mui/material";
import Typography from "@mui/material/Typography";
import RoomBox from "../Review/RoomBox";
import {getMaxPaxFromExtras, isDealerSite} from "../../../utils/utils";
import Paper from "@mui/material/Paper";
import {makeStyles} from "@mui/styles";
import {useDispatch, useSelector} from "react-redux";
import ActivityCard from "./ActivityCard";
import ActivityReviewBox from "./ActivityReviewBox";
import {useAuthUser, useIsAuthenticated} from "react-auth-kit";
import {SET_SELECTED_EXTRAS} from "../../../redux/constants/transactionConstants";
import {setTotalActivitiesFH} from "../../../redux/actions/totalActions";
import {getActivityList} from "../../../redux/actions/activitiesActions";
import NautilusTextInput from "../../Common/NautilusTextInput";

const useStyles = makeStyles({
    root: {
        width: "100%",
        marginBottom: '20px'
    },
    container: {
        marginTop: 20,
        paddingBottom: '30px'
    },
    tableContainer: {
        marginTop: 50,
    },
    info: {
        display: 'grid',
        gridTemplateColumns: "1fr minmax(100px, auto)",
        gap: '20px',
        "@media (max-width: 767px)": {
            display: 'flex',
            flexDirection: 'column !important',
        }
    },
    table: {
        border: '1px solid rgba(0, 0, 0, 0.87) !important',
        borderBottom: '0',
    },
    tableRow: {
        display: "grid",
        gridTemplateColumns: "minmax(350px, auto) minmax(150px, auto) minmax(150px, auto) minmax(250px, auto)",
        borderBottom: '1px solid rgba(0, 0, 0, 0.87)',
        "@media (max-width: 1000px)": {
            gridTemplateColumns: "minmax(250px, auto) 150px 150px 100px",
        },
        "@media (max-width: 700px)": {
            gridTemplateColumns: "1fr 100px",
        },
    },
    tableRowSecond: {
        display: "grid",
        gridTemplateColumns: "1fr 150px",
        "@media (max-width: 1000px)": {
            gridTemplateColumns: "1fr 100px",
        },
    },
    borderRight: {
        borderRight: '1px solid rgba(0, 0, 0, 0.87)',
        "@media (max-width: 600px)": {
            textAlign: 'left !important'
        }
    },
});
const ActivityBookingReview = ({
                                   clientBookingRef,
                                   setClientBookingRef,
                                   clientName,
                                   setClientName,
                                   showClientRef=true
                               }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const auth = useAuthUser();
    const isAuth = useIsAuthenticated();
    const activities = useSelector(state => state.activities);
    const transactions = useSelector(state => state.transactions);
    const { extra, guestInfo = [], ...transactionsRest } = transactions;
    const totals = useSelector((state) => state.totalsExtras);

    const [localGuestInfo, setLocalGuestInfo] = useState([]);
    // Look for the corresponding Activity

    const selectedActivity = (activityId) =>{ return Object.values(activities.extra).find(
        (activity) => String(activity.id) === activityId
    )};
    useEffect(() => {
        dispatch(getActivityList()).then(() => {
            const storedTransactions = sessionStorage.getItem('transactions');
            if (storedTransactions) {
                const parsed = JSON.parse(storedTransactions);
                dispatch({
                    type: SET_SELECTED_EXTRAS,
                    payload: parsed.extra || {}
                });
            }
            validateExtras();
        });
    }, []);

    const validateExtras = () => {
        if (!extra || Object.keys(extra).length === 0) return;
        const cleanedExtra = {};
        for (const company in extra) {
            const activities = extra[company];
            const validActivities = {};

            for (const activityId in activities) {
                const value = activities[activityId];
                if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                    validActivities[activityId] = value;
                }
            }

            if (Object.keys(validActivities).length > 0) {
                cleanedExtra[company] = validActivities;
            }
        }

        dispatch({
            type: SET_SELECTED_EXTRAS,
            payload: cleanedExtra
        });

        const maxPax = getMaxPaxFromExtras(cleanedExtra);

        let initialGuests = [];
        if (guestInfo.length > 0) {
            // Usa lo que haya en guestInfo, rellenando si hay menos que maxPax
            initialGuests = [...guestInfo];
            while (initialGuests.length < maxPax) {
                initialGuests.push({ firstName: '', lastName: '' });
            }
        } else {
            // Si no hay datos previos, crea vacíos
            initialGuests = Array.from({ length: maxPax }, () => ({
                firstName: '',
                lastName: ''
            }));
        }

        setLocalGuestInfo(initialGuests);

        sessionStorage.setItem(
            'transactions',
            JSON.stringify({ ...transactionsRest, extra: cleanedExtra, guestInfo: initialGuests })
        );

        dispatch(setTotalActivitiesFH());
    };

    const updateGuestField = (index, field, value) => {
        const updated = [...localGuestInfo];
        updated[index][field] = value;
        setLocalGuestInfo(updated);

        const updatedTransactions = { ...transactions, guestInfo: updated };
        sessionStorage.setItem('transactions', JSON.stringify(updatedTransactions));

        // En caso de que quieras también actualizar Redux aquí (opcional)
        // dispatch({ type: 'UPDATE_GUEST_INFO', payload: updated });
    };

    return (
        <>
        <Paper className={classes.root}>
            <List style={{width: "100%", padding: 0}}>
                <ListItem
                    alignItems={"flex-start"}
                    style={{
                        padding: 10,
                        margin: 0,
                        backgroundColor: "#000000",
                        color: "#ffffff",
                    }}
                    className="pricingMobile"
                >
                    <Grid
                        container
                        direction="row"
                        spacing={3}
                        alignItems={"center"}
                        justify={"center"}
                    >
                        <Grid item sm={4}/>
                        <Grid item sm={3}>
                            <Typography
                                variant="h5"
                                component="h5"
                                align="center"
                                style={{fontSize: "1.8rem"}}
                            >
                                Activity
                            </Typography>
                        </Grid>
                        <Grid item sm={2}>
                            <Typography
                                variant="h5"
                                component="h5"
                                align="center"
                                style={{fontSize: "1.8rem"}}
                            >
                                No. of Spaces
                            </Typography>
                        </Grid>
                        <Grid item sm={3}>
                            <Typography
                                variant="h5"
                                component="h5"
                                align="center"
                                style={{fontSize: "1.8rem"}}
                            >
                                Price
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>
                {totals.activityItems && totals.activityItems.length>0 && totals.activityItems.map((item,index)=>
                    selectedActivity(item.id) && <ActivityReviewBox
                        key={index}
                        activityInfo={selectedActivity(item.id)}
                        activitySelection={item}
                    />
                )}

                <ListItem
                    alignItems={"flex-start"}
                    style={{paddingTop: 12, paddingBottom: 12, margin: 0}}
                    className="pricingMobile"
                >
                    <Grid
                        container
                        direction="row"
                        spacing={3}
                        alignItems={"center"}
                        justify={"center"}
                    >
                        <Grid item sm={9}>
                            <Typography variant="h4" component="h4" align="left">
                                Tax ({totals.tax * 100}%)
                            </Typography>
                        </Grid>
                        <Grid item sm={3}>
                            <Typography variant="h4" component="h4" align="center">
                                ${totals.taxes.formatMoney(2)}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>
                {isDealerSite() && isAuth() && (
                    <ListItem
                        alignItems={"flex-start"}
                        style={{paddingTop: 12, paddingBottom: 12, margin: 0}}
                        className="pricingMobile"
                    >
                        <Grid
                            container
                            direction="row"
                            spacing={3}
                            alignItems={"center"}
                            justify={"center"}
                        >
                            <Grid item sm={9}>
                                <Typography variant="h4" component="h4" align="left">
                                    Commission ({auth().commission * 100}%)
                                </Typography>
                            </Grid>
                            <Grid item sm={3}>
                                <Typography variant="h4" component="h4" align="center">
                                    $
                                    {(
                                        (totals.total) *
                                        auth().commission
                                    ).formatMoney(2)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </ListItem>
                )}

                {totals.total > 0 && (
                    <ListItem
                        alignItems={"flex-start"}
                        style={{
                            paddingTop: 12,
                            paddingBottom: 12,
                            margin: 0,
                            backgroundColor: "#f2f2f2",
                        }}
                    >
                        <Grid
                            container
                            direction="row"
                            spacing={3}
                            alignItems={"center"}
                            justify={"center"}
                        >
                            <Grid item sm={9}>
                                <Typography variant="h4" component="h4" align="left">
                                     <strong>{`Total`}</strong>
                                </Typography>
                            </Grid>
                            <Grid item sm={3}>
                                <Typography variant="h4" component="h4" align="center">
                                    <strong>
                                        ${(isDealerSite() && isAuth() ? totals.total - (totals.total * auth().commission): totals.total).formatMoney(2)}
                                    </strong>
                                </Typography>
                            </Grid>
                        </Grid>
                    </ListItem>
                )}
            </List>
        </Paper>
            {isDealerSite() && showClientRef && <Paper className={classes.root} sx={{marginTop: 5, marginBottom: 5}}>
                <Grid container spacing={3}>
                    <Grid
                        item
                        xs={12}
                        style={{marginLeft: "20px", marginRight: "20px"}}
                    >
                        <Typography
                            variant="h3"
                            style={{fontWeight: "600", fontSize: "1.8rem"}}
                        >
                            Is This a Client Booking?
                        </Typography>
                        <Typography style={{marginTop: "10px"}}>
                            If this is for a booking within your own company and you have a
                            client name or booking reference number, please add these below.
                            These will be included in booking confirmation emails for
                            reference.
                        </Typography>
                    </Grid>
                    {/*<Grid style={{margin: "20px", marginTop: "0"}} item xs={12}>
                        <NautilusTextInput
                            fullWidth
                            name="clientName"
                            value={clientName || ''}
                            onChange={(e) => setClientName(e.target.value)}
                            label="Booking Client Name"
                            variant="outlined"
                        />
                    </Grid>*/}
                    <Grid style={{margin: "20px", marginTop: "-20px"}} item xs={12}>
                        <NautilusTextInput
                            fullWidth
                            name="clientBookingRef"
                            value={clientBookingRef || ''}
                            onChange={(e) => setClientBookingRef(e.target.value)}
                            label="Booking Client Reference"
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </Paper>}
        <Paper className={classes.root} sx={{ marginTop: 5, marginBottom: 5 }}>
            <Grid container spacing={3} style={{ padding: 20 }}>
                <Grid item xs={12}>
                    <Typography variant="h4" component="h4">
                        Guest(s) Information
                    </Typography>
                </Grid>
                {localGuestInfo.map((guest, index) => (
                    <React.Fragment key={index}>
                        <Grid item xs={6} sm={6}>
                            <NautilusTextInput
                                fullWidth
                                label={index===0 ?`(Group Leader) First Name`:`First Name ${index + 1}`}
                                variant="outlined"
                                value={guest.firstName}
                                onChange={(e) =>
                                    updateGuestField(index, 'firstName', e.target.value)
                                }
                            />
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <NautilusTextInput
                                fullWidth
                                label={index===0 ?`(Group Leader) Last Name`:`Last Name ${index + 1}`}
                                variant="outlined"
                                value={guest.lastName}
                                onChange={(e) =>
                                    updateGuestField(index, 'lastName', e.target.value)
                                }
                            />
                        </Grid>
                    </React.Fragment>
                ))}
            </Grid>
        </Paper>

        </>
    );
};

export default ActivityBookingReview;